import { render } from "./PromotionMain.vue?vue&type=template&id=e0329a36"
import script from "./PromotionMain.vue?vue&type=script&lang=js"
export * from "./PromotionMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__